import { QueryClient } from '@tanstack/react-query';

// global query client that can be used outside of a hook but stays in sync with the rest of the app
let queryClient: QueryClient | null = null;

export const getQueryClient = (reset?: boolean) => {
    if (!queryClient || reset) {
        queryClient = new QueryClient({});
    }

    return queryClient;
};
